import React, { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNotificationService } from '../../hooks/useNotificationService';

interface AuthNotificationWrapperProps {
  children: React.ReactNode;
}

const AuthNotificationWrapper: React.FC<AuthNotificationWrapperProps> = ({ children }) => {
  const { isAuthenticated, user, error } = useAuth();
  const notificationService = useNotificationService();

  // Show login success notification
  useEffect(() => {
    if (isAuthenticated && user) {
      notificationService.showOperationSuccess('login');
    }
  }, [isAuthenticated, user, notificationService]);

  // Show authentication errors
  useEffect(() => {
    if (error) {
      notificationService.handleApiError(new Error(error), 'Authentication');
    }
  }, [error, notificationService]);

  // Listen for logout events
  useEffect(() => {
    const handleLogout = () => {
      notificationService.showOperationSuccess('logout');
    };

    window.addEventListener('auth-logout', handleLogout);
    return () => window.removeEventListener('auth-logout', handleLogout);
  }, [notificationService]);

  return <>{children}</>;
};

export default AuthNotificationWrapper;